var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-container"},[_c('AuthTabs',{attrs:{"active":"register"}}),_c('div',{staticClass:"col-md-12 text-left d-flex justify-content-center"},[_c('signUpstudent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }